import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateSearchQuery } from "../../store/slices/tableSlice";
import { SearchBar, Pagination, TableItemsPackage } from '../../components'
import { closeModal } from "../../store/slices/deleteModalSlice";
import { fetchDataPackage } from "../../store/slices/apiPackageSlice";
import AddModalPackage from "../Modals/AddModalPackage";

const TablePackage = () => {
  const dispatch = useDispatch();
  const { currentPage, itemsPerPage, searchQuery } = useSelector(
    (state) => state.table
  );
  const dataPackage = useSelector((state) => state.apiPackage.data);
  const [searchInput, setSearchInput] = useState("");


  useEffect(() => {
    dispatch(fetchDataPackage());
  }, []);

  const filteredData = dataPackage.filter((item) => {
    const name = item.name && item.name.toLowerCase().includes(searchQuery.toLowerCase())
    const catName = item.categoryName && item.categoryName.toLowerCase().includes(searchQuery.toLowerCase())
    return name || catName
  });

  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentItems = filteredData.slice(firstIndex, lastIndex);

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(updateSearchQuery(searchInput));
  };

  return (
    <div className="p-3">
      <div className="flex items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
        <div>
          <button className="text-blue-500 mx-2" alt="you can edit here">
            <AddModalPackage
              title="Shto një pako"
              submitButtonText="Shto pakon"
              onCancel={handleCloseModal}
              namePackage="Emri i pakosë"
              packageCategory="Zgjedh kategorinë"
              priceValue="Cmimi"
              adminValue="Cmimi i adminit"
              schoolValue="Cmimi i autoshkolles"
            />
          </button>
        </div>
      </div>
      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                Emri i Pakosë
              </th>
              <th scope="col" className="px-6 py-3">
                Kategoria
              </th>
              <th scope="col" className="px-6 py-3">
                Çmimi
              </th>
              <th scope="col" className="px-6 py-3">
                Çmimi i Autoshkollës
              </th>
              <th scope="col" className="px-6 py-3">
                Çmimi i Adminit
              </th>
              <th scope="col" className="px-6 py-3">
                Muajt
              </th>
              <th scope="col" className="px-6 py-3">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <TableItemsPackage
              dataPackage={currentItems}
            />
          </tbody>
        </table>
        <Pagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          filteredData={filteredData}
        />
      </div>
    </div>
  );
};

export default TablePackage;


